/* Visionneuse plein écran des visuels produit.
   Module autonome : il lit la galerie déjà présente dans le DOM (vignettes,
   image principale) et ne modifie rien dans assets/product.js. À la
   fermeture, la synchronisation se fait en cliquant la vignette
   correspondante : le comportement existant est rejoué tel quel.

   Aucune chaîne en dur : les deux indications de zoom sont lues depuis les
   attributs data- posés par snippets/product-lightbox.liquid, seul endroit
   où le filtre | t est disponible. Les replis français ne servent que si le
   balisage provient d'un cache antérieur au déploiement. */
(function () {
  'use strict';

  var pl = document.getElementById('ProductLightbox');
  var plImg = document.getElementById('ProductLightboxImage');
  if (!pl || !plImg) return;

  var stage = pl.querySelector('[data-pl-stage]');
  var counter = pl.querySelector('[data-pl-counter]');
  var prevBtn = pl.querySelector('[data-pl-prev]');
  var nextBtn = pl.querySelector('[data-pl-next]');
  var hint = pl.querySelector('[data-pl-hint]');
  if (!stage) return;

  function slice(nodes) { return Array.prototype.slice.call(nodes); }

  var thumbs = slice(document.querySelectorAll('.thumbnail-btn'));
  var mainImg = document.getElementById('ProductMainImage');

  /* On affiche d'abord le 1024 déjà en cache, puis on échange contre le
     2048 une fois chargé : pas d'écran noir à l'ouverture. */
  var items = thumbs.map(function (b) {
    return {
      full: b.dataset.zoom || b.dataset.image,
      preview: b.dataset.image,
      alt: b.dataset.alt || ''
    };
  });

  /* Produit à visuel unique : la bande de vignettes n'est pas rendue */
  if (!items.length && mainImg) {
    items = [{
      full: mainImg.getAttribute('data-zoom') || mainImg.currentSrc || mainImg.src,
      preview: mainImg.currentSrc || mainImg.src,
      alt: mainImg.alt || ''
    }];
  }
  if (!items.length) return;

  var index = 0;
  var pending = 0;
  var lastFocus = null;
  var hintTimer = null;
  var fine = !!(window.matchMedia && window.matchMedia('(pointer: fine)').matches);

  if (hint) {
    var fineText = hint.getAttribute('data-hint-fine') || "Cliquez sur l'image pour zoomer";
    var coarseText = hint.getAttribute('data-hint-coarse') || 'Double-tapez ou pincez pour zoomer';
    hint.textContent = fine ? fineText : coarseText;
  }

  /* Index courant lu dans la galerie : product.js maintient is-active */
  function activeIndex() {
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  /* ---------- Zoom ----------
     L'image agrandie déborde réellement son conteneur : le panoramique est
     assuré par le défilement natif (inertie iOS incluse) plutôt que par un
     glisser-déposer maison. */
  function isZoomed() { return pl.classList.contains('is-zoomed'); }

  function zoomAt(clientX, clientY) {
    var rect = plImg.getBoundingClientRect();
    var rx = rect.width ? (clientX - rect.left) / rect.width : 0.5;
    var ry = rect.height ? (clientY - rect.top) / rect.height : 0.5;
    rx = Math.min(Math.max(rx, 0), 1);
    ry = Math.min(Math.max(ry, 0), 1);

    pl.classList.add('is-zoomed');
    stage.classList.add('is-zoomed');
    stage.scrollLeft = (stage.scrollWidth - stage.clientWidth) * rx;
    stage.scrollTop = (stage.scrollHeight - stage.clientHeight) * ry;
    if (hint) hint.hidden = true;
  }

  function unzoom() {
    pl.classList.remove('is-zoomed');
    stage.classList.remove('is-zoomed');
    stage.scrollLeft = 0;
    stage.scrollTop = 0;
  }

  function toggleZoom(x, y) {
    if (isZoomed()) unzoom();
    else zoomAt(x, y);
  }

  /* ---------- Rendu ---------- */
  function render(i) {
    if (i < 0) i = 0;
    if (i > items.length - 1) i = items.length - 1;
    index = i;
    unzoom();

    var it = items[index];
    plImg.alt = it.alt;
    plImg.src = it.preview || it.full;

    if (it.full && it.preview && it.full !== it.preview) {
      var token = ++pending;
      var pre = new Image();
      pre.onload = function () { if (token === pending) plImg.src = it.full; };
      pre.src = it.full;
    }

    if (counter) counter.textContent = (index + 1) + ' / ' + items.length;

    var single = items.length < 2;
    if (prevBtn) { prevBtn.hidden = single; prevBtn.disabled = index === 0; }
    if (nextBtn) { nextBtn.hidden = single; nextBtn.disabled = index === items.length - 1; }
  }

  function focusables() {
    return slice(pl.querySelectorAll('button')).filter(function (b) {
      return !b.disabled && !b.hidden;
    });
  }

  function open(i) {
    lastFocus = document.activeElement;
    render(typeof i === 'number' ? i : activeIndex());
    pl.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    if (hint) {
      hint.hidden = false;
      clearTimeout(hintTimer);
      hintTimer = setTimeout(function () { hint.hidden = true; }, 3500);
    }

    var f = focusables();
    if (f.length) f[0].focus();
    document.addEventListener('keydown', onKeydown, true);
  }

  function close() {
    if (pl.hidden) return;
    unzoom();
    pl.hidden = true;
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    clearTimeout(hintTimer);
    document.removeEventListener('keydown', onKeydown, true);

    /* La galerie principale suit le visuel quitté */
    if (thumbs[index] && !thumbs[index].classList.contains('is-active')) {
      thumbs[index].click();
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function go(step) {
    if (items.length < 2) return;
    render(index + step);
  }

  function onKeydown(e) {
    if (pl.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); return; }
    if (e.key === 'ArrowRight') { e.preventDefault(); go(1); return; }
    if (e.key !== 'Tab') return;

    /* Piège à focus : la boîte de dialogue est modale */
    var f = focusables();
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Commandes de la visionneuse ---------- */
  slice(pl.querySelectorAll('[data-pl-close]')).forEach(function (b) {
    b.addEventListener('click', close);
  });
  if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

  /* Clic hors de l'image : fermeture. Une fois zoomé, le fond sert au
     panoramique et ne doit plus fermer. */
  stage.addEventListener('click', function (e) {
    if (e.target === plImg || isZoomed()) return;
    close();
  });

  if (fine) {
    plImg.addEventListener('click', function (e) { toggleZoom(e.clientX, e.clientY); });
  }

  /* Double-tap tactile. Le pincement reste géré nativement par le
     navigateur (touch-action), plus fluide qu'une implémentation maison. */
  var lastTap = 0;
  plImg.addEventListener('touchend', function (e) {
    if (e.changedTouches.length !== 1) return;
    var now = Date.now();
    if (now - lastTap < 320) {
      e.preventDefault();
      var t = e.changedTouches[0];
      toggleZoom(t.clientX, t.clientY);
      lastTap = 0;
    } else {
      lastTap = now;
    }
  }, { passive: false });

  /* Balayage entre visuels, uniquement hors zoom */
  if (items.length > 1) {
    var sx = 0, sy = 0, tracking = false;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || isZoomed()) { tracking = false; return; }
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    stage.addEventListener('touchend', function (e) {
      if (!tracking || isZoomed()) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx;
      var dy = t.clientY - sy;
      if (Math.abs(dx) < 45) return;
      if (Math.abs(dx) < Math.abs(dy) * 1.5) return;
      go(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* ---------- Ouverture depuis la page ---------- */
  var trigger = document.querySelector('[data-zoom-trigger]');
  if (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      open(activeIndex());
    });
  }

  /* L'image principale est cliquable. Garde-fou : un balayage se termine
     parfois par un clic, on ne l'interprète pas comme une demande de zoom. */
  if (mainImg) {
    var downX = 0, downY = 0, downT = 0;
    mainImg.addEventListener('pointerdown', function (e) {
      downX = e.clientX; downY = e.clientY; downT = Date.now();
    });
    mainImg.addEventListener('click', function (e) {
      if (Math.abs(e.clientX - downX) > 12 || Math.abs(e.clientY - downY) > 12) return;
      if (Date.now() - downT > 700) return;
      e.preventDefault();
      open(activeIndex());
    });
  }
})();
